export default __webpack_public_path__ + "static/media/AlgebraTableImg1.e5ff5ed7.PNG";